import React, { useEffect, useRef, useState } from "react";
import UnreadAnswersModal from "./unread_answers_modal";
import { createPortal } from "react-dom";

const UnreadAnswersNotifier = ({ unreadAnswersCount }) => {
	const [showModal, setShowModal] = useState(false);
	const modalShownRef = useRef(false);

	useEffect(() => {
		if (unreadAnswersCount > 0 && !modalShownRef.current) {
			modalShownRef.current = true;
			setShowModal(true);
		}
	}, [unreadAnswersCount]);

	return (
		<>
			{showModal && createPortal(<UnreadAnswersModal setShowModal={setShowModal} />, document.body)}
		</>
	);
};

export default UnreadAnswersNotifier;
